export default function Registration() {
  return (
    <section id="registro" className="py-24 bg-gradient-to-b from-[#0f274d] via-[#132f5d] to-[#0f274d] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold tracking-[0.3em] uppercase text-[#bb8800] mb-4">
            Regístrate
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold leading-tight mb-6">
            Asegura tu lugar en el Speed Mentoring
          </h2>
          <p className="text-lg text-white/80 max-w-3xl mx-auto">
            Completa el formulario para confirmar tu participación, recibir tu acceso al evento y entrar en contacto directo con nuestros mentores invitados.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-6">
            <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-3xl p-8 shadow-2xl">
              <h3 className="text-2xl font-semibold mb-4">¿Qué necesitas?</h3>
              <ul className="space-y-4 text-white/80 text-lg">
                <li className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#bb8800] text-sm font-bold text-white">1</span>
                  Tu correo institucional y datos de contacto para mantenerte informado.
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#bb8800] text-sm font-bold text-white">2</span>
                  Seleccionar las áreas de mentoría que más te interesan para asignarte sesiones relevantes.
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-[#bb8800] text-sm font-bold text-white">3</span>
                  Confirmar tu disponibilidad durante la jornada de Speed Mentoring.
                </li>
              </ul>
            </div>
            <div className="flex flex-wrap gap-4">
              <div className="flex-1 min-w-[200px] bg-white/10 rounded-2xl p-6 border border-white/10">
                <p className="text-sm uppercase tracking-wider text-white/70 mb-1">Cupo</p>
                <p className="text-3xl font-bold text-[#bb8800]">Limitado</p>
                <p className="text-sm text-white/80">Regístrate cuanto antes para asegurar tu espacio.</p>
              </div>
              <div className="flex-1 min-w-[200px] bg-white/10 rounded-2xl p-6 border border-white/10">
                <p className="text-sm uppercase tracking-wider text-white/70 mb-1">Modalidad</p>
                <p className="text-3xl font-bold text-[#bb8800]">Online</p>
                <p className="text-sm text-white/80">Conoce y convive con la comunidad Speed Mentoring.</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-white/10">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSfIbs5Pd7eOgmOLfATe-M_ojlLTBa9bGCFcALdfSPtvqnGDgA/viewform?embedded=true"
              width="100%"
              height="800"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Formulario de registro Speed Mentoring"
              className="w-full"
            >
              Cargando…
            </iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
